module.exports = [
    // {
    //     "_id": "6722be60-7aba-11ee-bdb8-77b5dac32536",
    //     "createdAt": "2023-11-04 02:32:30 UTC",
    //     "createdBy": "autodrip",
    //     "updatedAt": "2023-11-04 02:32:30 UTC",
    //     "updatedBy": "autodrip",
    //     "idAgent": "6b305505",
    //     "idBranch": "8dcdddd2",
    //     "idCompany": "9014f014",
    //     "idProgram": "1233",
    //     "idOrder": "14588623",
    //     "idOrderAddtnlShipped": "",
    //     // "idCart": "8276678",
    //     "editionId": "e1",
    //     "current_state": "ORDER_READY",
    //     // "current_state": "COMPLETE",
    //     // "current_state": "PENDING_USER_UPDATE",
    //     // "current_state": "START",
    //     // "current_state": "PENDING_AUTO_RETRY",
    //     // "current_state": "ORDER_ERROR",
    //     "current_state_info": "test",
    //     "transition_history": []
    // },
    // {
    //     "_id": "27c38150-7c86-11ee-bdb8-77b5dac32536",
    //     "createdAt": "2023-10-29 20:30:55 UTC",
    //     "createdBy": "kiran",
    //     "updatedAt": "2023-11-06 09:54:50 UTC",
    //     "updatedBy": "autodrip",
    //     "idAgent": "3f67bb91",
    //     "idBranch": "32517238",
    //     "idCompany": "d2dbadb1",
    //     "idProgram": "1233",
    //     "idOrder": "14499812",
    //     "idOrderAddtnlShipped": "",
    //     // "idCart": "8229676",
    //     "editionId": "e4",
    //     // "current_state": "COMPLETE",
    //     // "current_state": "FAILED",
    //     // "current_state": "ORDER_ERROR",
    //     "current_state": "ORDER_READY",
    //     "current_state_info": "test",
    //     "transition_history": [
    //         {
    //             "timestamp": "2023-11-05 20:30:55 UTC",
    //             "current_state": "PENDING_USER_UPDATE",
    //             "current_state_info": "test"
    //         }
    //     ]
    // },
    {
        "_id": "27c38150-7c86-11ee-bdb8-77b5dac32536",
        "createdAt": "2023-10-29 20:30:55 UTC",
        "createdBy": "kiran",
        "updatedAt": "2023-11-06 09:54:50 UTC",
        "updatedBy": "autodrip",
        "idAgent": "3f67bb91",
        "idBranch": "32517238",
        "idCompany": "d2dbadb1",
        "idProgram": "1233",
        "idOrder": "14499812",
        "idOrderAddtnlShipped": "",
        "idCart": "8229676",
        "editionId": "e2",
        "current_state": "COMPLETE",
        // "current_state": "FAILED",
        // "current_state": "ORDER_ERROR",
        // "current_state": "ORDER_READY",
        "current_state_info": "test",
        "transition_history": [
            {
                "timestamp": "2023-11-05 20:30:55 UTC",
                "current_state": "PENDING_USER_UPDATE",
                "current_state_info": "test"
            }
        ]
    },
];
